import { render, staticRenderFns } from "./AppNavigationHeaderTodayButton.vue?vue&type=template&id=7acd6201"
import script from "./AppNavigationHeaderTodayButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavigationHeaderTodayButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports